module.exports = __webpack_public_path__ + "img/서브4_시야.90befd87.svg";